import { createContext, useContext, useState } from 'react';
import { api } from './api.js';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('m2b_user') || 'null'); } catch { return null; }
  });

  async function login(email, password) {
    const r = await api.login(email, password);
    sessionStorage.setItem('m2b_token', r.token);
    sessionStorage.setItem('m2b_user', JSON.stringify(r.user));
    setUser(r.user);
    return r; // includes must_change_password
  }

  function logout() {
    sessionStorage.removeItem('m2b_token');
    sessionStorage.removeItem('m2b_user');
    setUser(null);
  }

  // Used after a successful change-password call to clear the must-change flag locally.
  function markPasswordChanged() {
    if (!user) return;
    const updated = { ...user, must_change_password: false };
    sessionStorage.setItem('m2b_user', JSON.stringify(updated));
    setUser(updated);
  }

  return (
    <AuthCtx.Provider value={{ user, login, logout, markPasswordChanged }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
